// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasKey = <T>(obj: T, key: keyof any): key is keyof T => typeof obj === 'object' && obj !== null && key in obj;
